import ClientTab from './ClientTab.vue';

export default ClientTab;
